import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

export default function Stats() {
    return (
        <Box
            id="stats"
            sx={{
                width: '100%',
                backgroundColor: '#141414', // Dark background for contrast
                py: 6, // Padding for spacing
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={2}> {/* Added spacing for mobile view */}
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            textAlign: 'center',
                            color: 'white',
                            borderRight: { sm: '1px solid white' }, // Thin white line for separation on larger screens
                            px: 2,
                            pb: { xs: 2, sm: 0 }, // Add spacing below items on mobile
                        }}
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '2.5rem',
                                mb: 1,
                            }}
                        >
                            6
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: '1rem',
                                color: 'rgba(255, 255, 255, 0.85)',
                            }}
                        >
                            Cities
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            textAlign: 'center',
                            color: 'white',
                            borderRight: { sm: '1px solid white' }, // Thin white line for separation on larger screens
                            px: 2,
                            pb: { xs: 2, sm: 0 }, // Add spacing below items on mobile
                        }}
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '2.5rem',
                                mb: 1,
                            }}
                        >
                            8
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: '1rem',
                                color: 'rgba(255, 255, 255, 0.85)',
                            }}
                        >
                            Programs
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            textAlign: 'center',
                            color: 'white',
                            px: 2,
                        }}
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: 'bold',
                                fontSize: '2.5rem',
                                mb: 1,
                            }}
                        >
                            14,000+
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: '1rem',
                                color: 'rgba(255, 255, 255, 0.85)',
                            }}
                        >
                            Members
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}
